import React from 'react';

var StoreLocation = function StoreLocation(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.354 21.48a2.014 2.014 0 0 1-2.846-.138C6.186 16.58 4 12.847 4 10c0-4.513 3.536-8 8-8s8 3.487 8 8c0 2.847-2.186 6.58-6.508 11.342-.044.049-.09.095-.138.138zM18 10c0-3.402-2.634-6-6-6s-6 2.598-6 6c0 2.2 1.98 5.58 5.99 9.998C16.02 15.58 18 12.2 18 10zm-6 3a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

StoreLocation.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { StoreLocation as icon };
export default iconHandler(StoreLocation);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/StoreLocation.js
// module id = 624
// module chunks = 0